import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { Admin_Code } from "../config/siteConfig";
import { apiClient } from "./api-client.service";
import { authStorageService } from "./auth-storage.service";

import type {
  SupplierWalletTransactionFilter,
  SupplierWalletTransactionResponse,
  SupplierWalletBalanceResponse,
} from "../types/supplier-wallet.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.supplierWallet;
const adminTransactions = SUPPLIER_BACKEND_API_ENDPOINTS.adminTransactions;

export const supplierWalletService = {
  async transactions(filter: SupplierWalletTransactionFilter): Promise<SupplierWalletTransactionResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      const isAdmin = Number(authStorageService.getUser()?.role_code) === Admin_Code;
      const transactionsEndpoint = isAdmin ? adminTransactions.transactions : endpoints.transactions;

      return await apiClient<SupplierWalletTransactionResponse>(transactionsEndpoint(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to load wallet transactions due to an unexpected error.",
        resData: null,
      };
    }
  },

  async balance(supplierCode: string): Promise<SupplierWalletBalanceResponse> {
    try {
      return await apiClient<SupplierWalletBalanceResponse>(endpoints.balance(supplierCode), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to load wallet balance due to an unexpected error.",
        resData: null,
      } as unknown as SupplierWalletBalanceResponse;
    }
  },
};
